import type { RootStateOrAny } from 'react-redux'
import { useSelector } from 'react-redux'

import { useAuth } from 'routes/Menu/domains/auth'
import { CollectionId } from 'routes/Menu/domains/collections'

export const CALORIES_TUTORIAL_NAME = 'customised_recipe_tiles_calories'

const SUPPORTED_COLLECTION_IDS = new Set<string>([
  CollectionId.AllRecipes,
  CollectionId.Recommendations,
])

export const useShouldShowCaloriesTutorial = (collectionId?: string) => {
  const { isAuthenticated } = useAuth()
  const hasDismissedTutorial = useSelector(({ tutorial }: RootStateOrAny) =>
    Boolean(tutorial && tutorial.getIn(['viewed', CALORIES_TUTORIAL_NAME])),
  )

  return Boolean(
    isAuthenticated &&
      collectionId &&
      SUPPORTED_COLLECTION_IDS.has(collectionId) &&
      !hasDismissedTutorial,
  )
}
